export const mailToSupport = 'mailto:support@diligent.com';
